import React from "react";
import "./App.css";
import "antd/dist/antd.css";
import { Switch, Route } from "react-router-dom";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
function App() {
  return (
    <div>
      <Switch>
        <Route path="/dashboard" component={Admin} />
        <Route path="/login" component={Login} />
      </Switch>
    </div>
  );
}

export default App;
